import { IS_ACTIVE, IS_HIDDEN, ACTIVATED } from '/source/js/base/baseClasses';
import errorModal from '../checkout/partials/errorModal.hbs';

export function nextStep() {
    let $this = $(this);
    let $checkoutStep = $('.checkout__form-step');
    let $checkoutItem = $this.parents('.checkout').find('.checkout__item.is--active');
    $checkoutItem.removeClass(IS_ACTIVE).addClass(ACTIVATED).next().addClass(IS_ACTIVE);
    $checkoutStep.addClass(IS_HIDDEN);
    $this.parents($checkoutStep).next().removeClass(IS_HIDDEN);
}
export function prevStep() {
    let $this = $(this);
    let $checkoutStep = $('.checkout__form-step');
    let $checkoutItem = $this.parents('.checkout').find('.checkout__item.is--active');
    $checkoutItem.removeClass(IS_ACTIVE).prev().addClass(IS_ACTIVE).removeClass(ACTIVATED);
    $checkoutStep.addClass(IS_HIDDEN);
    $this.parents($checkoutStep).prev().removeClass(IS_HIDDEN);
}
export function goToStep() {
    let $this = $(this);
    let stepName = $this.attr('id');
    let $checkoutStep = $('.checkout__form-step');
    let $checkoutItem = $('.checkout__item');
    $checkoutStep.addClass(IS_HIDDEN);
    $(`.checkout__form-step--${stepName}`).removeClass(IS_HIDDEN);
    $checkoutItem.removeClass(IS_ACTIVE).removeClass(ACTIVATED);
    $(`.checkout__item--${stepName}`).addClass(IS_ACTIVE);
}

export function orderError() {
    let $checkoutResponse = $('.checkout__response');
    let errorDiv = `<div class="checkout-error" role="alert"></div>`;
    $checkoutResponse.html(errorDiv);
    $('.checkout-error ').append(errorModal);
    $(window).scrollTop(0);
}
